import { FC } from 'react';
import { Link } from 'react-router-dom';

import { SearchInstanceSubjectsDto, SearchOption } from '@app/components';
import { useSearchContext } from '@app/contexts';
import { useQueryParams } from '@app/hooks';
import { generateRouteParams } from '@app/utils';
import { Route } from '@app/constants';

import css from './RelatedSubjects.module.scss';

interface RelatedSubjectsProps {
  subjects: SearchInstanceSubjectsDto;
}

export const RelatedSubjects: FC<RelatedSubjectsProps> = ({ subjects }) => {
  const queryParams = useQueryParams();
  const { setInstanceIdScrollTo } = useSearchContext();

  return (
    <div className={css.wrapper}>
      {subjects.map(subject => (
        <Link
          to={generateRouteParams({
            pathname: Route.search,
            query: {
              ...queryParams,
              pageNumber: '1',
              option: SearchOption.subject,
              query: subject?.value ?? subject,
            },
          })}
          className={css.link}
          key={subject?.value ?? subject}
          onClick={() => setInstanceIdScrollTo(null)}
        >
          {subject?.value ?? subject}
        </Link>
      ))}
    </div>
  );
};
